import styled from "styled-components";
import colors from "../../assets/styles/colors";

export const LifeInsuranceContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 44px 20px 15px 20px;
  background: ${colors.bgGray};
`;

export const LifeInsuranceWrapper = styled.div``;

export const LifeInsuranceHeader = styled.div``;

export const LifeInsuranceHeaderTitle = styled.div`
  font-size: 12px;
  color: ${colors.textSecondary};
`;

export const LifeInsuranceHeaderArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LifeInsuranceContent = styled.div`
  width: 100%;
  max-width: 610px;
  padding-top: 20px;
  padding-bottom: 20px;
`;

export const LifeInsuranceLineFormLabel = styled.div`
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.textPrimary};
`;

export const LifeInsuranceLineFormItem = styled.div`
  margin-top: 30px;
`;

export const LifeInsuranceAddLine = styled.button`
  font-weight: bold;
  border: 0;
  outline: 0;
  margin-top: 20px;
  background-color: transparent;
  font-size: 14px;
  line-height: 17px;
  color: ${colors.bgSecondary};
  cursor: pointer;
`;

export const LifeInsuranceLineFormHeaderItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LifeInsuranceLineFormDeleteItem = styled.span`
  cursor: pointer;
  color: ${colors.bgDanger};
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
`;
